skrilla.directive('affiliates',function() {
    return {
        templateUrl: 'directives/affiliates/affiliates.html',
        scope: {
        },
        controller: function($scope, searchService, modalService){
            $scope.selected = 0;
            $scope.tabs = [
                {title: "Affiliates"},
                {title: "Income Access Reports"}
            ]
            $scope.search = function(){
                searchService.get("affiliates").then(function(response){
                    $scope.affiliates = response.data.result;
                });
            }
            $scope.search();

            $scope.create = function(){
                modalService.openModal("views/createAffiliate/createAffiliate.html", true, 'lg', true, true, function(){
                    $scope.search();
                });
            }

        }
    };
});
